import {createContext, useContext, useState, useCallback} from 'react';

const NotificationsContext = createContext();

let notificationId = 0;

export const NotificationsProvider = ({children}) => {
    const [notifications, setNotifications] = useState([]);

    const removeNotification = useCallback((id) => {
        setNotifications(prev => prev.filter(n => n.id !== id));
    }, []);

    const addNotification = useCallback((message, type = 'info', duration = 5000) => {
        const id = ++notificationId;
        const notification = {
            id,
            message,
            type, // 'success', 'error', 'warning', 'info'
            duration,
            minimized: false,
            position: {x: Math.random() * 200 + 50, y: Math.random() * 200 + 50} // Posición inicial aleatoria
        };

        setNotifications(prev => [...prev, notification]);

        if (duration > 0) {
            setTimeout(() => {
                removeNotification(id);
            }, duration);
        }

        return id;
    }, [removeNotification]);

    const minimizeNotification = useCallback((id) => {
        setNotifications(prev => prev.map(n =>
            n.id === id ? {...n, minimized: !n.minimized} : n
        ));
    }, []);

    const updatePosition = useCallback((id, position) => {
        setNotifications(prev => prev.map(n =>
            n.id === id ? {...n, position} : n
        ));
    }, []);

    const value = {
        notifications,
        addNotification,
        removeNotification,
        minimizeNotification,
        updatePosition
    };

    return (
        <NotificationsContext.Provider value={value}>
            {children}
        </NotificationsContext.Provider>
    );
};

export const useNotifications = () => {
    const context = useContext(NotificationsContext);
    if (!context) {
        throw new Error('useNotifications must be used within a NotificationsProvider');
    }
    return context;
};